import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Row, Col, Form } from 'react-bootstrap'
import { primaryColorOpacity, primaryColor } from 'utils/colors'
import { PaymentImage } from './PaymentImage'
import { PaymentSteps } from './PaymentSteps'
import { IPaymentMethod } from 'interfaces/IPaymentMethod'
import { useState } from 'react'

/**
 * Custom interface for the Payment card
 */
interface Props {
    /**
     * The payment method information
     */
    method: IPaymentMethod;
    /**
     * on change callback function to pass it to a parent component
     */
    onChange: () => Promise<boolean>;
}

/**
 * A payment card component to show the information of the method
 */
export const PaymentCard = ({ method, onChange }: Props) => {
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const [isActive, setIsActive] = useState<boolean>(method.is_active || false);
    const [collapsed, setCollapsed] = useState<boolean>(true);

    /**
     * method that activates/deactivates the payment method
     */
    const onChangeStatus = async () => {
        setIsActive(!isActive);
        setIsDisabled(true);
        const data = await onChange();
        setIsActive(data ? !isActive : isActive);
        setIsDisabled(false);
    }

    return (
        <div
            className="m-1 p-2 justify-items-center d-flex flex-column mb-4"
            style={{
                backgroundColor: primaryColorOpacity,
                border: `2px solid ${primaryColor}`,
                borderRadius: "9px",
                marginBottom: "20px",
                marginTop: "20px",
                boxShadow: "0 10px 20px 0 rgba(0, 0, 0, 0.4)",
                fontSize: "20px"
            }}
        >
            <Row style={{ height: "35px" }}>
                <Col xs={3} />
                <Col className="text-center" xs={6}>
                    <strong className="text-center mt-3">{method.name}</strong>
                </Col>
                <Col className="text-end" xs={3} style={{ height: "fit-content", fontSize: "35px" }}>
                    <Form.Switch disabled={isDisabled} onChange={() => onChangeStatus()} checked={isActive} className="me-3" style={{ height: "fit-content" }} />
                </Col>
            </Row>
            <PaymentImage type={method.type} />
            <span className="ms-2 mt-1" >{method.description}</span>
            <div className='ms-2' onClick={() => setCollapsed(!collapsed)}>
                <strong>Procedimiento para el cliente</strong>
                <FontAwesomeIcon
                    icon={collapsed ? faSortDown : faSortUp}
                    className="ms-2 align-self-center"
                />
            </div>
            {!collapsed && <PaymentSteps type={method.type} />}
        </div>
    )
}
